export default "__VITE_ASSET__DKeYoqOR__"